import { CopyOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Button, message, Popconfirm } from "antd";
import { PopconfirmProps } from "antd/lib/popconfirm";
import React from "react";

export type IPopconfirm = PopconfirmProps;

const DuplicateIcon: React.FC<any> = (props) => {
    const {
        isButton = false,
        type,
        size,
        onConfirm,
        title = "Are you sure to duplicate this?",
        onCancel = () => message.error("Cancel"),
        okText = "Yes",
        cancelText = "No",
    } = props;

    let buttonSize = "default";

    if (size === "sm") {
        buttonSize = "small";
    } else if (size === "lg") {
        buttonSize = "large";
    }

    return (
        <Popconfirm
            title={title}
            icon={<QuestionCircleOutlined />}
            onConfirm={onConfirm}
            onCancel={onCancel}
            okText={okText}
            cancelText={cancelText}
        >
            {isButton ? (
                <Button
                    htmlType={type}
                    size={buttonSize}
                    icon={<CopyOutlined />}
                    shape="circle"
                    {...props}
                />
            ) : (
                <CopyOutlined />
            )}
        </Popconfirm>
    );
};

export default DuplicateIcon;
